import { Paper, Typography } from '@mui/material';
import SimpleProfileCard from '../../components/SimpleProfileCard/SimpleProfileCard';
import SimpleWorkingAreaCard from '../../components/SimpleWorkingAreaCard/SimpleWorkingAreaCard';

import './YourWorkingAreaCard.scss';

function YourWorkingAreaCard({
  className,
  managerImageURL, managerName, workingAreaMessageToAgent,
  agentAreaId, agentAreaDescription, handleGoToWorkingAreaDetails
}) {
  const classes = `your-working-area ${className}`;
  return (
    <div className={classes}>
      <div className="inner-container">
        <div className="agent-working-area-intro">
          <div
            className="msg-container"
            elevation={1}>
            <Paper className="msg">
              <Typography
                variant="p"
                component="p">
                {workingAreaMessageToAgent}
              </Typography>
            </Paper>
          </div>
          <div className="agent-manager-info">
            <SimpleProfileCard
              className="manager-image"
              userPictureURL={managerImageURL}
            />
            <Typography
              className="manager-name"
              variant="p"
              component="p">
              {managerName}
            </Typography>
          </div>
        </div>
        <SimpleWorkingAreaCard
          className="your-area"
          workingAreaId={agentAreaId}
          description={agentAreaDescription}
          showDetailsLabel
          handleGoToWorkingAreaDetails={handleGoToWorkingAreaDetails}
        />
      </div>
    </div>
  );
}

export default YourWorkingAreaCard;
